import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';
import { eFavoriteType } from '../enums/favorite/favorite-type.enum';


export const FAVORITE_TYPES: SelectOption<eFavoriteType>[] = [
    {
        label: "מסלול",
        value: eFavoriteType.ROUTES
    },
    {
        label: "קו",
        value: eFavoriteType.LINES
    },
    {
        label: "תחנה",
        value: eFavoriteType.STATIONS
    },
];
